import React, { useEffect, useRef } from 'react';

//Material
//Components
import Page from '../../components/Page';

//Blocks
import 'animate.css';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  setIsOpenAuthModal,
  setIsOpenChangeMailModal,
  setIsOpenDeleteAccModal,
  setIsOpenEnable2FAModal,
  setIsOpenPremiumCancelModal,
  setIsOpenPremiumModal,
  setUserData,
  setUserSubscribers,
  setUserSubscriptions
} from '../../redux/mainReducer';
import { base } from '../../redux/thunk';
import './index.css';
import { useSnackbar } from 'notistack';

// import { useSelector } from 'react-redux';

function AccSettingsPage({ language, userData, getBlockedUsersThunk, getSavedCardsThunk }) {
  const iframe = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const dataSender = async () => {
    iframe.current.contentWindow.postMessage(
      {
        userData,
        tokens: {
          accessToken: localStorage.getItem('accessToken'),
          refreshToken: localStorage.getItem('refreshToken')
        }
      },

      '*'
    );
  };

  // useEffect(() => {
  //   if (iframe) {
  //     dataSender();
  //     // setTimeout(dataSender, 200);
  //   }
  //   // eslint-disable-next-line
  //   return () => clearTimeout(dataSender);
  //   // eslint-disable-next-line
  // }, [iframe]);
  const iFrameMessageReceiveParent = (event) => {
    // window.removeEventListener('message', iFrameMessageReceiveParent);
    if (event.origin === `https://${window.location.hostname}`) {
      // if (event.origin === 'https://localhost:3001') {
      if (event?.data && event?.data === 'RENDERED') {
        dataSender();
      }
      if (event?.data && event?.data === 'PASSWORD CHANGED') {
        enqueueSnackbar('Пароль успішно змінено!', { variant: 'success' });
        iframe.current.contentWindow.postMessage(
          {
            userData: {},
            premiumSubscription: {},
            tokens: {
              accessToken: '',
              refreshToken: ''
            }
          },

          '*'
        );

        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('feedbackModal');
        dispatch(setUserData({}));
        dispatch(setUserSubscribers([]));
        dispatch(setUserSubscriptions([]));
        window.removeEventListener('message', iFrameMessageReceiveParent);
        dispatch(setIsOpenAuthModal(true));
        navigate(`/${language}`);
      }
      if (event?.data && event?.data === 'CARDS CHANGED') {
        getSavedCardsThunk();
        window.removeEventListener('message', iFrameMessageReceiveParent);
      }
      if (event?.data && event?.data === 'EMAIL CHANGED') {
        dispatch(setIsOpenChangeMailModal(true));
        window.removeEventListener('message', iFrameMessageReceiveParent);
      }
      if (event?.data && event?.data === 'PREMIUM CANCEL') {
        dispatch(setIsOpenPremiumCancelModal(true));
        window.removeEventListener('message', iFrameMessageReceiveParent);
      }
      if (event?.data && event?.data === 'NAV TO TARIFFS') {
        navigate('/ua/tariffs');
        window.removeEventListener('message', iFrameMessageReceiveParent);
      }
      if (event?.data && event?.data.includes('NAV TO USER')) {
        navigate(`/ua/user-page/${event?.data.substring(14)}`);
        window.removeEventListener('message', iFrameMessageReceiveParent);
      }
      if (event?.data && event?.data === 'PREMIUM CHOOSE') {
        dispatch(setIsOpenPremiumModal(true));
        window.removeEventListener('message', iFrameMessageReceiveParent);
      }
      if (event?.data && event?.data?.message && event?.data?.message === 'REFRESH') {
        localStorage.setItem('accessToken', `${event?.data?.tokens?.accessToken}`);
        localStorage.setItem('refreshToken', `${event?.data?.tokens?.refreshToken}`);
        window.removeEventListener('message', iFrameMessageReceiveParent);
      }
      if (event?.data && event?.data === 'REFRESH ERROR') {
        iframe.current.contentWindow.postMessage(
          {
            userData: {},
            premiumSubscription: {},
            tokens: {
              accessToken: '',
              refreshToken: ''
            }
          },

          '*'
        );
        window.removeEventListener('message', iFrameMessageReceiveParent);
        dispatch(setUserData({}));
        dispatch(setUserSubscribers([]));
        dispatch(setUserSubscriptions([]));
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('feedbackModal');
        window.location.href = '/';
      }
      if (event?.data && event?.data === 'REFRESHBLOCKED') {
        getBlockedUsersThunk();
        window.removeEventListener('message', iFrameMessageReceiveParent);
      }
      if (event?.data && event?.data === 'ACCDELETE') {
        dispatch(setIsOpenDeleteAccModal(true));
        window.removeEventListener('message', iFrameMessageReceiveParent);
      }
      if (event?.data && event?.data === '2FAENABLE') {
        dispatch(setIsOpenEnable2FAModal(true));
        window.removeEventListener('message', iFrameMessageReceiveParent);
      }
      if (event?.data && event?.data === '2FADISABLED') {
        enqueueSnackbar('Двофакторну аутентифікацію вимкнено!', {
          variant: 'success'
        });
        window.removeEventListener('message', iFrameMessageReceiveParent);
      }
    }
    window.addEventListener('message', iFrameMessageReceiveParent, false);
  };
  useEffect(() => {
    window.addEventListener('message', iFrameMessageReceiveParent, false);

    // window.addEventListener('message', (event) => console.log(event));
    return () => window.removeEventListener('message', iFrameMessageReceiveParent);
    // eslint-disable-next-line
  }, []);

  return (
    <Page
      title="Налаштування акаунта"
      sx={{
        display: 'flex',
        marginTop: '150px',
        alignItems: 'center',
        flexDirection: 'column',
        height: 'max-content',
        padding: { xs: '0px 0px', sm: '0px 20px', md: '0px 50px', lg: '0px 100px' }
      }}
    >
      <iframe
        id="accSettingsPage"
        ref={iframe}
        title="accSettingsPage"
        src={`https://${window.location.hostname}/v1/settings/`}
        // src="https://localhost:3001/v1/settings"
        style={{
          width: '100%',
          maxWidth: '720px',
          height: '100vh',
          border: 'none',
          paddingRight: '0px'
        }}
      ></iframe>
    </Page>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    premiumSubscription: state.global.premiumSubscription
  };
};

export default connect(mapStateToProps, {
  getBlockedUsersThunk: base.getBlockedUsersThunk,
  getSavedCardsThunk: base.getSavedCardsThunk
})(AccSettingsPage);
